if(document.querySelector('.registerbtn')) document.querySelector('.registerbtn').addEventListener('click', function (e){
  let password = document.getElementById('RegisterForm-password').value;
  let confirmPassword = document.getElementById('RegisterForm-confirm-password').value;
  let email = document.getElementById('RegisterForm-email').value;
  let firstName = document.getElementById('RegisterForm-FirstName').value;
  let lastName = document.getElementById('RegisterForm-LastName').value;
  let notMatchPassword = document.querySelector('.notmatchpassword');
  let createCustomerForm = document.getElementById('create_customer');
  if(password !== confirmPassword){
    e.preventDefault();
    e.stopImmediatePropagation();
    notMatchPassword.style.display = 'block';
  }else{
    notMatchPassword.style.display = 'none';
    if(email !== '' && password !== '' && confirmPassword !== '' && firstName !== '' && lastName !== '') {
      createCustomerForm.submit();
    }
  }
});
var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
var backreset =  document.querySelector('.back-reset');
var toploginbtn = document.querySelector('.login-top-btn');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
    if(document.querySelector('.back-reset')){
      backreset.classList.add('hide-form');
    }
    if(document.querySelector('.login-top-btn')){
      toploginbtn.classList.remove('hide-form');
    }
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
    if(document.querySelector('.back-reset')){
      backreset.classList.remove('hide-form');
    }
     if(document.querySelector('.login-top-btn')){
      toploginbtn.classList.add('hide-form');
    }
  });
}
window.addEventListener('load', function(){
  const inputs = document.querySelectorAll('.customer .input-field input');
  inputs.forEach(function(input){
    if(input.value){
      input.classList.add('filled');
    }
    input.addEventListener('input', function(){
      if(input.value){
        input.classList.add('filled');
      }else{
        input.classList.remove('filled');
      }
    });
  });
});
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
    document.querySelectorAll('.account-wrap .input-field').forEach(function (element){
      var label = element.querySelector('.account-wrap .input-field label');
      var input = element.querySelector('.account-wrap .input-field input, .account-wrap .input-field select');
      if(label && input){
        if(input.tagName === 'INPUT'){
          var width = label.offsetWidth + 24;
          input.style.paddingLeft = width + 'px';
        }else if(input.tagName === 'SELECT'){
          var width = label.offsetWidth + 24;
          input.style.paddingLeft = width + 'px';
        }
        input.addEventListener('click', function(){
          if(this.tagName === 'INPUT'){
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
          }else if(input.tagName === 'SELECT'){
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
          }
        });
      }
    });
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    var destroyId = this.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}

if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.address_form_new').classList.toggle('active-open-form');

    document.querySelectorAll('.account-wrap .input-field').forEach(function (element) {
      var label = element.querySelector('.account-wrap .input-field label');
      var input = element.querySelector('.account-wrap .input-field input, .account-wrap .input-field select');
    
      if (label && input) {
        if (input.tagName === 'INPUT') {
          var width = label.offsetWidth + 24;
          input.style.paddingLeft = width + 'px';
        } else if (input.tagName === 'SELECT') {
            var width = label.offsetWidth + 24;
            input.style.paddingLeft = width + 'px';
          }
        
        input.addEventListener('click', function () {
          if (this.tagName === 'INPUT') {
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
          } else if (input.tagName === 'SELECT') {
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
          }
        });
      }
    });
  });
}
var accountpopup = document.querySelector('.account-popup-wrap');
var loginpopup = document.querySelector('.hide-login');
var registerpopup = document.querySelector('.snippet-account-popup .customer.register');

if(document.getElementById('cus-account')){
  document.getElementById('cus-account').addEventListener('click',function(e){
   if(document.querySelector('.account-popup-wrap')){
      document.body.classList.remove('open-menu');
      // accountpopup.style.display = 'block';
      document.body.classList.add('active-popup'); 
     }
    else{
      window.location.reload();
    }
 });
}
if(document.getElementById('login-first')){
    document.getElementById('login-first').addEventListener('click',function(e){
     loginpopup.classList.remove('hide-login');
     registerpopup.classList.add('hide-login');
  });
}
if(document.getElementById('register-first')){
  document.getElementById('register-first').addEventListener('click',function(e){
    loginpopup.classList.add('hide-login');
    registerpopup.classList.remove('hide-login');
  });
}
document.querySelectorAll('.close-popup').forEach(function(closeButton){
  closeButton.addEventListener('click',function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    document.body.classList.remove('active-popup');
    accountpopup.style.display = 'none';
    loginpopup.classList.add('hide-login');
    registerpopup.classList.remove('hide-login');
  });
});
// =============
document.querySelectorAll('.input-field').forEach(function (element) {
  var label = element.querySelector('label');
  var input = element.querySelector('input, textarea');
  if(label && input){
    if (input.tagName === 'TEXTAREA'){
      var height = label.offsetHeight + 30;
      input.style.paddingTop = height + 'px';
    }
  }
  if(input){
    input.addEventListener('click', function(){
      if (this.tagName === 'TEXTAREA'){
        var height = label.offsetHeight + 30;
        this.style.paddingTop = height + 'px';
      }
   });
  }
});
// default check 
document.querySelectorAll('.address-list .non-active-default').forEach(function(ele){
  ele.addEventListener('click', function() {
    var dataid = this.getAttribute('data-id-id');
    var addform = document.querySelectorAll('.address-form .address-edit-form');
    addform.forEach(function(newaddress){
      var addressId = newaddress.getAttribute('data-id');
      console.log("addressId", addressId);
      if(dataid === addressId){
       var checkbox = document.querySelectorAll('input[type="checkbox"]');
       checkbox.forEach(function(check){
         check.checked = true;
       });
       var checkform = newaddress.querySelector('form');
        if(checkform){
          checkform.submit();
          console.log("success");
        }
       else{
         console.log("error");
       }
     }
    });
  });
});